<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-strategy</v-icon>{{ item['uuid'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <ProfileStrategyForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <template>
      <div class="profilestrategyquality-list">
        <Toolbar
          :handle-add="() => addHandlerSub('ProfileStrategyQuality',item)"
        />

        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex sm12>
              <h1>{{$t('profile.strategy.qualities')}}</h1>
            </v-flex>
            <v-flex lg12>
              <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                <ProfileStrategyQualityFilterForm
                  ref="filterForm"
                  :values="filters"
                  slot="filter"
                />
              </DataFilter>

              <br />

              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="itemsSub"
      :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                :loading="isLoading"
                :loading-text="$t('global.loading')"
                :options.sync="options"
                :server-items-length="totalItems"
                class="elevation-1"
                item-key="@id"
                show-select
                @update:options="onUpdateOptions"
@click:row="editHandlerSubEvent"
              >

                <ActionCell
                  slot="item.action"
                  slot-scope="props"
                  :handle-edit="() => editHandlerSub(item,'ProfileStrategyQuality',props.item)"
                ></ActionCell>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ProfileStrategyForm from '../../components/profilestrategy/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ProfileStrategyQualityFilterForm from '../../components/profilestrategyquality/Filter';
import DataFilter from '../../components/DataFilter';

const servicePrefix = 'ProfileStrategy';

export default {
  name: 'ProfileStrategyUpdate',
  servicePrefix,
  mixins: [ListMixin,UpdateMixin],
  components: {
    Loading,
    Toolbar,
    ProfileStrategyForm,
    ActionCell,
    ProfileStrategyQualityFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.strategy.quality'), value: 'quality.name' },
        { text: this.$t('profile.strategy.part'), value: 'part' },
        { text: this.$t('profile.strategy.infill'), value: 'infill' },
        { text: this.$t('profile.strategy.support'), value: 'support' },
        { text: this.$t('profile.strategy.densesupport'), value: 'denseSupport' },
        { text: this.$t('profile.strategy.skirt'), value: 'skirt' },
        { text: this.$t('profile.strategy.raft'), value: 'raft' },
        { text: this.$t('profile.strategy.primepillar'), value: 'primePillar' },
        { text: this.$t('profile.strategy.oozeshield'), value: 'oozeShield' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'profileStrategy' : this.$route.params.id,
      },
      selected: []
    };
  },
  computed: {
    ...mapFields('profilestrategy', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('profilestrategy', ['find']),
    ...mapGetters('profilestrategyquality', {
      itemsSub: 'list'
    }),
    ...mapFields('profilestrategyquality', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })

  },

  methods: {
    ...mapActions('profilestrategy', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    ...mapActions('profilestrategyquality', {
      getPage: 'fetchAll',
    }),
    editHandlerSubEvent(value) {
      this.editHandlerSub(this.item,'ProfileStrategyQuality',value);
    }
  }
};
</script>
